import { useForm } from "react-hook-form";
import z from "zod";
import { MiControlledTextField, MiModal } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { zodResolver } from "@hookform/resolvers/zod";
import { useAreaTemplateViewModel } from "./useAreaTemplateViewModel";

const schema = z.object({
  name: z.string().min(1, "Template Name is required"),
});

export function AreaTemplateModal({ open, onClose }: AreaTemplateModalProps) {
  const {
    formState: { isValid },
    control,
    getValues,
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: { name: "" },
    resolver: zodResolver(schema),
  });

  const handleCloseModal = () => {
    onClose();
    reset();
  };

  const { isLoading, handleCreateAreaTemplate } = useAreaTemplateViewModel({
    handleCloseModal,
  });

  return (
    <MiModal
      open={open}
      closeModal={handleCloseModal}
      title="Area Template"
      description="Enter name to save current areas as an Area Template."
      loading={isLoading}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: handleCloseModal,
        },
        {
          name: "Save",
          disabled: !isValid || isLoading,
          variant: BUTTON_VARIANTS.CONTAINED,
          onClick: async () => {
            const { name } = getValues();
            await handleCreateAreaTemplate(name);
          },
        },
      ]}
    >
      <MiControlledTextField
        formControl={control}
        name="name"
        label="Area Template Name"
      />
    </MiModal>
  );
}

interface AreaTemplateModalProps {
  open: boolean;
  onClose: () => void;
}
